import { Box, BottomNavigation, BottomNavigationAction, Paper, Fab } from '@mui/material';

/**
 * Notch dinámico
 */
const NotchedBackground = ({ fabSize = 68 }) => {
  const notchWidth = fabSize + 40;
  const center = 200;

  return (
    <svg
      width='100%'
      height='80'
      viewBox='0 0 400 80'
      preserveAspectRatio='none'
      style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
      }}
    >
      <path
        d={`
          M0,0 
          H400 
          V80 
          H0 
          Z
        `}
        fill='white'
      />
      <line x1='0' y1='0' x2='400' y2='0' stroke='rgba(0, 0, 0, 0.12)' strokeWidth='2' />
    </svg>
  );
};

export default function MobileBottomBar({
  value,
  onChange,
  actions = [],
  fab = null,
  height = 72,
  fabSize = 64,
  activeColor = '#1976d2',
  inactiveColor = '#9e9e9e',
}) {
  const middleIndex = Math.floor(actions.length / 2);

  return (
    <Box sx={{ pb: `${height}px` }}>
      {/* FAB */}
      {fab && (
        <Fab
          onClick={fab.onClick}
          sx={{
            position: 'fixed',
            bottom: 30,
            left: '50%',
            transform: 'translateX(-50%)',
            width: fabSize,
            height: fabSize,
            backgroundColor: '#007AFF',
            color: '#fff',
            zIndex: 20,
            border: '6.5px solid #cae4fdff',
            boxShadow: 'none',
            // boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.06)',
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: '#0071E3',
              boxShadow: '0 4px 16px rgba(0, 122, 255, 0.25), 0 1px 4px rgba(0, 0, 0, 0.06)',
            },
            '&:active': {
              transform: 'translateX(-50%) scale(0.96)',
            },
            '& .MuiSvgIcon-root': {
              fontSize: '2rem',
            },
          }}
        >
          {fab.icon}
        </Fab>
      )}

      {/* NAVBAR */}
      <Paper
        elevation={0}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          height,
          zIndex: 10,
        }}
      >
        {/* Fondo con notch */}
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            boxShadow: '0px -2px 12px rgba(0,0,0,0.08)',
          }}
        >
          {fab && <NotchedBackground fabSize={fabSize} />}
        </Box>

        <BottomNavigation
          value={value}
          onChange={(e, newValue) => onChange(newValue)}
          showLabels
          sx={{
            position: 'relative',
            height: 40,
            backgroundColor: 'transparent',
            '& .MuiBottomNavigationAction-root': {
              color: inactiveColor,
              fontSize: 12,
              paddingTop: '10px',
              minWidth: 'auto',
            },
            '& .Mui-selected': {
              color: activeColor,
            },
          }}
        >
          {actions.map((action, index) => {
            // Insertar hueco en el medio si hay FAB
            if (fab && index === middleIndex) {
              return [
                <BottomNavigationAction
                  key='fab-space'
                  icon={<span style={{ width: fabSize }} />}
                  disabled
                  sx={{ width: '20%' }}
                />,
                <BottomNavigationAction
                  key={action.value}
                  label={action.label}
                  icon={action.icon}
                  value={action.value}
                  onClick={(e) => action?.onClick?.(e)}
                  sx={{
                    width: '20%',
                    color: inactiveColor,
                    '&.Mui-selected': {
                      color: activeColor,
                    },
                  }}
                />,
              ];
            }

            return (
              <BottomNavigationAction
                key={action.value}
                label={action.label}
                icon={action.icon}
                value={action.value}
                onClick={(e) => action?.onClick?.(e)}
                sx={{
                  width: '20%',
                  color: inactiveColor,
                  '&.Mui-selected': {
                    color: activeColor,
                  },
                }}
              />
            );
          })}
        </BottomNavigation>
      </Paper>
    </Box>
  );
}
